//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMySendList } from '@/service/dingding';
import { getMyReceiveList } from '@/service/service';
import waybillItem from './waybillItem';
export default {
    name: 'online-waybillNo-list',
    components: {
        waybillItem
    },
    data() {
        return {
            currentTab: 'RECEIVE', // 我寄的 - 'SEND', wo'shou 'RECEIVE'
            senderList: [],
            senderListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            },
            receiveList: [],
            receiveListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            }
        };
    },
    methods: {
        init() {
            this.openid = window.localStorage.getItem('openid');
            this.source = window.localStorage.getItem('source');
            this.userid = window.localStorage.getItem('userid');
            this.changeTab(this.currentTab);
            this.initScroll();
        },
        // 上拉加载方法
        initScroll() {
            this.$nextTick(() => {
                // 我发送的
                const scrollDom = document.getElementById('sender-list');
                scrollDom.onscroll = () => {
                    const scrollTop = scrollDom.scrollTop;
                    const clientHeight = scrollDom.clientHeight;
                    const scrollHeight = scrollDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (this.senderListPagination.hasNext) {
                            this.senderListPagination.pageNo += 1;
                            this.getSendList();
                        }
                    }
                };
                // 我收到的
                const scrollReceiveDom = document.getElementById(
                    'receive-list'
                );
                scrollReceiveDom.onscroll = () => {
                    const scrollTop = scrollReceiveDom.scrollTop;
                    const clientHeight = scrollReceiveDom.clientHeight;
                    const scrollHeight = scrollReceiveDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (this.receiveListPagination.hasNext) {
                            this.receiveListPagination.pageNo += 1;
                            this.getReceiveList();
                        }
                    }
                };
            });
        },
        // 下拉刷新
        refresh() {
            // TODO
        },
        sendMessage(item) {
            if (this.currentTab === 'SEND') {
                this.$emit('sendMessage', item.mailNo ? item.mailNo : item.orderNo);
            } else {
                this.$emit('sendMessage', item.mailNo);
            }
            this.$emit('close');
        },
        // 切换tab
        changeTab(type) {
            this.currentTab = type;
            if (type === 'SEND') {
                this.getSendList();
            } else {
                this.getReceiveList();
            }
        },
        // 关闭当前窗口
        close() {
            this.$emit('close');
        },

        // 手动收入订单
        goSetOrder() {
            this.$emit('goSetOrder');
        },

        // 我寄的
        getSendList() {
            if (!this.userid) {
                return;
            }
            getMySendList({
                // userid: "1330437178689974274",
                userid: this.userid,
                source: this.source,
                pageNo: this.senderListPagination.pageNo,
                limit: this.senderListPagination.limit
            }).then(res => {
                const result = res.data;
                if (result && result.items) {
                    const newList = result.items;
                    let list = this.senderList;
                    if (this.senderListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    this.senderList = list;
                    this.senderListPagination = {
                        pageNo: result.pageNo,
                        limit: result.limit,
                        total: result.total,
                        hasNext: result.pageNo * result.limit < result.total
                    };
                } else {
                    this.senderList = [];
                    this.senderListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        },

        // 我收的
        getReceiveList() {
            if (!this.userid) {
                return;
            }
            getMyReceiveList({
                // userid: ":task:" + this.openid,
                // userid: "1331881598127812609",
                userid: this.userid,
                pageNo: this.receiveListPagination.pageNo,
                limit: this.receiveListPagination.limit,
                source: this.source
            }).then(res => {
                const result = res.data;
                if (result && result.items) {
                    const newList = result.items.map(item => {
                        return {
                            ...item,
                            createTime: item.orderCreateTime,
                            senderProvinceName: item.senderCityName,
                            receiverProvinceName: item.receiverCityName
                        };
                    });
                    let list = this.receiveList;
                    if (this.receiveListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    this.receiveList = list;
                    this.receiveListPagination = {
                        pageNo: Number(result.pageNo),
                        limit: Number(result.limit),
                        total: Number(result.total),
                        hasNext: res.morePage
                    };
                } else {
                    this.receiveList = [];
                    this.receiveListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/chat/waybillnosList.vue